// Hit-map debug overlay (?hitmap=1) — samples the whole viewport through
// the REAL hit-testing path (document.elementFromPoint, which honors
// border-radius/clip-path exactly like a finger does) and tints each cell:
//   green  = tap reaches the stage → LGM build-targeting works here
//   red    = tap claimed by a control (dial, buttons, bar, sheets…)
// The overlay itself is pointer-events:none, so sampling sees through it.
//
// Persistence: the ?hitmap=1 param is stashed in sessionStorage so the
// overlay survives the lobby→join reload; the ✕ chip clears it.

const FLAG_KEY = 'bolo2k.hitmap';
const STEP = 22; // px between samples — fine enough to show dial curvature

export function hitmapRequested(): boolean {
  if (new URLSearchParams(location.search).get('hitmap') === '1') {
    try {
      sessionStorage.setItem(FLAG_KEY, '1');
    } catch {
      // storage unavailable — param-only activation still works this load
    }
    return true;
  }
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

export function initHitmap(): void {
  const canvas = document.createElement('canvas');
  canvas.style.cssText =
    'position:fixed;inset:0;z-index:9998;pointer-events:none;image-rendering:pixelated;';

  const chip = document.createElement('button');
  chip.type = 'button';
  chip.style.cssText =
    'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:9999;' +
    'font:12px ui-monospace,Menlo,monospace;letter-spacing:1px;padding:6px 12px;' +
    'background:rgba(4,8,4,.92);color:#7fbf7f;border:2px solid #7fbf7f;cursor:pointer;';

  const sample = (): void => {
    const w = innerWidth;
    const h = innerHeight;
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, w, h);
    let mapCells = 0;
    let total = 0;
    for (let y = STEP / 2; y < h; y += STEP) {
      for (let x = STEP / 2; x < w; x += STEP) {
        const el = document.elementFromPoint(x, y);
        if (!el) continue;
        total++;
        const isStage = el.id === 'stage' || !!el.closest('#stage-wrap');
        if (isStage) {
          mapCells++;
          ctx.fillStyle = 'rgba(80, 220, 80, 0.28)';
        } else {
          ctx.fillStyle = 'rgba(255, 70, 50, 0.42)';
        }
        ctx.fillRect(x - STEP / 2 + 1, y - STEP / 2 + 1, STEP - 2, STEP - 2);
      }
    }
    const pct = total ? Math.round((mapCells / total) * 100) : 0;
    chip.textContent = `HITMAP ${pct}% map-tappable · tap=resample · ✕`;
  };

  chip.addEventListener('click', (e) => {
    // Right edge of the chip (the ✕) closes; anywhere else resamples.
    const r = chip.getBoundingClientRect();
    if (e.clientX > r.right - 28) {
      try {
        sessionStorage.removeItem(FLAG_KEY);
      } catch {
        // best-effort
      }
      canvas.remove();
      chip.remove();
      return;
    }
    sample();
  });

  document.body.append(canvas, chip);
  // First sample after the HUD/controls have mounted and laid out.
  setTimeout(sample, 600);
  window.addEventListener('resize', () => setTimeout(sample, 300));
}
